import { useAtomValue } from 'jotai';
import { FC, Suspense, useMemo } from 'react';
import { PreloadCampaignBanner } from '~/components/campaign-carousel/preload';
import { $Locale, $RootTraffic } from '@lemon8/web-app-shared/atom';
import { FirstArticleCardPreload } from './image-preload';
import { TDK } from './tdk';
import { OG } from './og';
import { DiscoverSmartBanner } from './smart-banner';
import { JsonLD } from '@discover/head/json-ld';

export const DiscoverHead: FC = () => {
  const { enterHref: href } = useAtomValue($RootTraffic);
  const { region } = useAtomValue($Locale);

  const canonical = useMemo(() => {
    const u = new URL(href);
    return `https://${u.hostname}${u.pathname}?region=${region}`;
  }, [href]);

  return (
    <>
      <Suspense>
        <TDK />
      </Suspense>
      <link rel="canonical" href={canonical} />
      <DiscoverSmartBanner />
      <PreloadCampaignBanner />
      <OG />
      <Suspense>
        <FirstArticleCardPreload />
        <JsonLD />
      </Suspense>
    </>
  );
};
